<template>
  <div class="scholarList_content">
    <!--    <div style="height: 1px; background-color: #eeeeee"></div>-->
    <div class="scholar-list">
      <el-empty
        description=""
        v-if="personListData === null || personListData.length === 0"
      ></el-empty>

      <div
        class="person-view"
        v-for="(scholarItem, index) in personListData"
        :key="index"
      >
        <div class="scholar-item pointer justify-between">
          <div class="item-left">
            <div class="flex" @click="goPersonalDetails(scholarItem.id)">
              <div
                class="avatar-rate flex-column items-center"
                style="width: 90px; flex-shrink: 0"
              >
                <el-avatar
                  class="avatar"
                  :size="80"
                  :src="scholarItem.avatar"
                />
              </div>
              <div class="scholar-text">
                <div style="display: flex; max-width: 500px">
                  <span class="scholar-name">{{ scholarItem.name }}</span>

                  <div
                    class="org-content ellipsis"
                    style="max-width: 300px"
                    v-if="
                      scholarItem.showTitle &&
                      scholarItem.showTitle.length !== 0
                    "
                  >
                    <div
                      class="field-content ellipsis name-title-box"
                      :title="title"
                      v-for="(title, index) in scholarItem.showTitle"
                      :key="index"
                    >
                      {{ title }}
                    </div>
                  </div>
                </div>
                <div class="infor-item" >
                  <div class="content-title" v-if="scholarItem.org_name">
                    所在机构：
                  </div>
                  <el-tooltip
                    effect="light"
                    :content="toChinese || scholarItem.org_name"
                    placement="top"
                    :enterable="false"
                    popper-class="translate-popper"
                  >
                    <div
                      class="org-content pointer"
                      v-if="scholarItem.org_name"
                      @click.stop="toOrgDetail(scholarItem)"
                      @mouseenter="enterToChineseFn(scholarItem.org_name)"
                      @mouseleave="leaveToChineseFn"
                    >
                      {{ scholarItem.org_name }}
                    </div>
                  </el-tooltip>
                </div>

                <div class="infor-item"  v-if="scholarItem.nativePlace">
                  <div class="content-title">
                    籍贯：
                  </div>
                  <div
                    class="org-content pointer"
                    v-if="scholarItem.nativePlace"
                  >
                    {{ scholarItem.nativePlace }}
                  </div>
                </div>

                <div class="infor-item" v-if="scholarItem.position">
                  <div class="content-title">
                    职务：
                  </div>
                  <div
                    class="org-content ellipsis"
                    style="max-width: 120px; display: block"
                    v-if="scholarItem.position"
                  >
                    {{ scholarItem.position }}
                  </div>
                </div>

                <div class="infor-item" v-if="scholarItem.awardsText">
                  <div class="content-title">
                    奖项：
                  </div>
                  <div
                    class="org-content"
                    style="max-width: 190px"
                    v-if="scholarItem.awardsText"
                  >
                    <el-tooltip
                      effect="light"
                      :content="`${scholarItem.awardsText}\n${toChinese}`"
                      placement="top"
                      :enterable="false"
                      popper-class="translate-popper"
                    >
                      <template slot="content">
                        <p>{{ scholarItem.awardsText }}</p>
                        <p>{{ toChinese }}</p>
                      </template>
                      <div
                        class="field-content ellipsis"
                        @mouseenter="enterToChineseFn(scholarItem.awardsText)"
                        @mouseleave="leaveToChineseFn"
                        style="color: #333333"
                      >
                        {{ scholarItem.awardsText }}
                      </div>
                    </el-tooltip>
                  </div>
                </div>
                <div
                  class="infor-item"
                  v-if="
                    scholarItem.innovation_index_l1 ||
                    scholarItem.publications_count ||
                    scholarItem.hindex ||
                    scholarItem.hIndex ||
                    scholarItem.citedby
                  "
                >
                  <div
                    class="content-title"
                    :style="
                      scholarItem.innovation_index_l1 &&
                      scholarItem.innovation_index_l1 !== '0'
                        ? 'margin-left: 0px'
                        : ''
                    "
                    v-if="
                      scholarItem.publications_count &&
                      scholarItem.publications_count !== '0'
                    "
                  >
                    成果数：
                  </div>
                  <div
                    class="org-content"
                    v-if="
                      scholarItem.publications_count &&
                      scholarItem.publications_count !== '0'
                    "
                  >
                    {{ scholarItem.publications_count }}
                  </div>
                  <div
                    class="content-title"
                    :style="
                      scholarItem.publications_count &&
                      scholarItem.publications_count !== '0'
                        ? 'margin-left: 34px'
                        : ''
                    "
                    v-if="
                      (scholarItem.hindex && scholarItem.hindex !== '0') ||
                      (scholarItem.hIndex && scholarItem.hIndex !== '0')
                    "
                  >
                    H指数：
                  </div>
                  <div
                    class="org-content"
                    v-if="scholarItem.hIndex && scholarItem.hIndex !== '0'"
                  >
                    {{ scholarItem.hIndex }}
                  </div>
                  <div
                    class="org-content"
                    v-if="scholarItem.hindex && scholarItem.hindex !== '0'"
                  >
                    {{ scholarItem.hindex }}
                  </div>
                  <div
                    class="content-title"
                    :style="
                      (scholarItem.publications_count &&
                        scholarItem.publications_count !== '0') ||
                      (scholarItem.hindex && scholarItem.hindex !== '0')
                        ? 'margin-left: 34px'
                        : ''
                    "
                    v-if="scholarItem.citedby && scholarItem.citedby !== '0'"
                  >
                    引用数：
                  </div>
                  <div
                    class="org-content"
                    v-if="scholarItem.citedby && scholarItem.citedby !== '0'"
                  >
                    {{ scholarItem.citedby }}
                  </div>
                </div>
                <!--  个人主页  -->
                <div class="infoLine flex items-center" style="margin-top: 10px">
                  <span class="flex items-center">个人主页：</span>
                  <div
                    style="
                      width: 21px;
                      height: 21px;
                      border-radius: 50%;
                      background-color: #3860F4;
                    "
                    :style="{
                      backgroundColor: scholarItem.person_url
                        ? '#3860F4'
                        : '#999999',
                    }"
                    class="pointer flex justify-center items-center"
                    @click.stop="goInfoUrl(scholarItem.person_url)"
                  >
                    <img
                      width="14px"
                      height="14px"
                      :src="require('@/assets/images/talent/boshi.png')"
                      alt=""
                    />
                  </div>
                  <div
                    style="
                      width: 21px;
                      height: 21px;
                      border-radius: 50%;
                      margin-left: 10px;
                    "
                    :style="{
                      backgroundColor: scholarItem.googleAddress
                        ? '#3860F4'
                        : '#999999',
                    }"
                    class="flex justify-center items-center pointer"
                    @click.stop="goInfoUrl(scholarItem.googleAddress)"
                  >
                    <img
                      width="14px"
                      height="14px"
                      :src="require('@/assets/images/talent/google.png')"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-column items-center"
               style="width: 100px;
               flex-shrink: 0;
               margin-top: 10px;
               border: 1px solid transparent;
           ">
            <div
              class="load-button"
              v-if="scholarItem.scholarReportVisible"
              @click.stop="getReport('scholar', scholarItem.id, scholarItem.name)"
            >
              人才报告
            </div>
            <div
              v-if="scholarItem.citationReportVisible"
              class="load-button"
              @click.stop="getReport('citation', scholarItem.googleId, scholarItem.name)"
            >
              引文报告
            </div>
          </div>
        </div>

        <div class="flex honor-container">
          <el-tooltip
            effect="light"
            :content="toChinese || honorItem"
            placement="top"
            :enterable="false"
            popper-class="translate-popper"
            v-for="(honorItem, index) in scholarItem.showLeftList"
            :key="index"
          >
            <span
              class="honor-item"
              @mouseenter="enterToChineseFn(honorItem)"
              @mouseleave="leaveToChineseFn"
            >
              {{ honorItem }}
            </span>
          </el-tooltip>
        </div>

        <div
          class="field"
          v-if="scholarItem.fields && scholarItem.fields.length !== 0"
        >
          <div
            class="content-title"
            style="min-width: 70px"
            v-if="scholarItem.fields && scholarItem.fields.length !== 0"
          >
            研究领域：
          </div>
          <div
            class="field-content ellipsis"
            v-for="(field, index) in scholarItem.fields"
            :key="index"
          >
            <el-tooltip
              effect="light"
              :content="`${field.name}${toChinese}`"
              placement="top"
              :enterable="false"
              popper-class="translate-popper"
            >
              <span
                @mouseenter="enterToChineseFn(field.name)"
                @mouseleave="leaveToChineseFn"
              >{{ index === 0 ? '' : '；' }}{{ field.name }}</span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmptyView from '@/components/emptyView.vue';
import {
  getCiteReportApi,
  getScholarReportApi,
} from '@/api/talent';
import { translateToChinese } from '@/utils/translateToChinese';

export default {
  name: 'searchScholarList',
  components: { EmptyView },
  props: [
    'personList',
    'isTechSearch',
    'innovationType',
    'cityType',
    'backName',
    'refreshList'
  ],
  data() {
    return {
      userId: '', // userId
      checkAll: false, // 是否全选
      isIndeterminate: false,
      checkScholarList: [], // 已选人才id

      personListData: [], // 接收的人才列表数据

      page: 1,
      //人才触达
      person: {
        personDialogTableVisible: false,
        personData: [],
        totalElements: 0,
      },
      contactWayVisible: false,
      phone: null,
      email: null,
      pushDialogVisible: false,
      scholarId: null,
      scholarName: null,
      toChinese: '',
    };
  },
  created() {
    // 从localStorage中获取用户id
    this.userId = localStorage.getItem('at_userId') || 'test';
  },
  computed: {},
  methods: {
    // 跳转主页
    goInfoUrl(url) {
      if (url) {
        window.open(url);
      }
    },
    // 跳转详情
    toOrgDetail(item) {
      let id = item.org_id;
      let type = item.org_type;
      let isBack = '1';
      let backName = '搜索';
      let area = item.source == 'zhitu' ? '国内' : '国外';

      let obj = {
        name: 'orgDetail',
        query: { id, area, type, isBack, backName },
      };
      this.$router.push(obj);
    },
    toDetail(id, type) {
      let path = '';
      if (type === 'paper') {
        path = '/paperDetail';
      } else if (type === 'patent') {
        path = '/patentDetail';
      } else {
        path = '/projectDetail';
      }
      this.$router.push({
        path: path,
        query: { id: id, isBack: '1', backName: this.backName },
      });
    },
    getSpTitle(title) {
      let title1 = '';
      title.split(' <').map((item, index) => {
        if (index === 0 && !item.includes('<span')) {
          item = '...';
        } else if (item.startsWith('span')) {
          item = ' <' + item;
        }
        title1 += item;
      });
      return title1;
    },
    goPersonalDetails(id) {
      if (id) {
        let obj = {
          name: 'talentDetailGuoJiao',
          query: {
            id: id,
          },
        };
        this.$router.push(obj)
        // let routeData = this.$router.resolve(obj);
        // window.open(routeData.href, '_blank');
      } else {
        this.$message.warning({
          message: '暂无详情数据',
          type: 'warning',
        });
      }
    },

    // 人才报告、引文报告
    async getReport(type, id, name) {
      if (!id) return;

      this.$loading.showLoading();

      // // 校验账号下载次数
      // const remainingData = await remainingApi({
      //   username: this.userId,
      // })
      //
      // // 报告下载次数为0，禁止下载
      // if (remainingData.scholar_citation_remaining === 0) {
      //   this.$message.warning('下载次数已达上限，如有需要请联系运营人员设置权限!');
      //   this.$loading.hideLoading();
      //   return false;
      // }

      let params = { id, name };
      let Api = type === 'scholar' ? getScholarReportApi : getCiteReportApi;
      Api(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('报告生成中,请稍后到“文件管理”中查看');

            // // 生成成功后可用次数减1
            // consumeApi({
            //   username: this.userId,            // 用户名
            //   service_type: "scholar_citation", // scholar_citation（学者引文）、literature_review（文献综述）
            // }).then(res => {
            //   console.log(res);
            // })
          } else if (res.code === 406) {
            this.$message.warning('下载次数已达上限，如有需要请联系运营人员设置权限!');
          }
          this.$loading.hideLoading();
        })
        .catch(() => {
          this.$message.error('报告生成失败，请稍后重试!');
          this.$loading.hideLoading();
        })
        .finally(() => {
          this.$loading.hideLoading();
        });
    },


    // 鼠标移入翻译成中文(荣誉称号、奖项等)
    enterToChineseFn(name) {
      const isEn = !/[\u4E00-\u9FA5]+/g.test(name);

      // 没有汉字翻译成中文
      if (isEn) {
        translateToChinese(name).then((res) => {
          this.toChinese = res;
        });
      }
    },
    leaveToChineseFn() {
      this.toChinese = '';
    },

  },
  watch: {
    personList: {
      handler(val) {
        this.personListData = val;
      },
      deep: true,
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .el-dialog {
  margin-top: 3vh !important;
}

.scholarList_content {
  //background-color: white;
  .scholar-list {
    width: 100%;
    //display: grid;
    //grid-template-columns: 1fr 1fr; /* 两列等宽 */
    //gap: 20px; /* 设置元素之间的间距 */
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
}

.scholar-text {
  margin-left: 13px;
  //max-width: 800px;
  width: auto;
}

.scholar-name {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
  white-space: nowrap;
  cursor: pointer;
  margin-right: 10px;

  //&:hover {
  //  color: #6F64AD;
  //}
}

.honor-container {
  margin-top: 15px;
}

.honor-item {
  font-size: 12px;
  margin-right: 7px;
  padding: 6px;
  background-color: rgba(47, 112, 255, 0.08);
  color: #3860F4;
  border-radius: 12px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.alert-title {
  font-size: 10px;
  margin-left: 5px;
  font-weight: normal;
  padding: 0 5px;
  background-color: #ffefe5;
  color: #fe8b00;
  border-radius: 2px;
}

.content-title {
  font-size: 14px;
  color: #8191B2;
}

.org-content {
  font-size: 14px;
  display: flex;
  color: #50607F;
}
.person-view {
  width: 49%;
  background-color: #fff;
  border-radius: 15px;
  border: 1px solid #EDEDED;
  padding: 20px;
  box-sizing: border-box;
  //box-shadow: 0px 2px 7px 1px rgba(16, 53, 102, 0.1);
}
.scholar-item {
  flex-shrink: 0;
  display: flex;
  //align-items: center;
  //justify-content: space-between;
  padding: 0;
  line-height: 1.2;

  /deep/ .el-avatar {
    img {
      width: 100%;
    }
  }
  .avatar-rate {
    .company-patent {
      padding-top: 2px;
      margin-left: -2px;
    }
    /deep/ .el-rate {
      font-size: 16px;
      .el-rate__item {
        .el-rate__icon {
          margin-right: 0 !important;
        }
        .el-icon-star-on:before {
          font-size: 16px !important;
        }
      }
    }
  }
  .avatar {
    cursor: pointer;
    transition: all 0.3s ease 0.1s;

    &:hover {
      transform: scale(1.1);
    }
  }
}

.item-left {
  display: flex;
  //width: calc(100% - 170px);
  //padding: 16px 20px;
  flex-shrink: 0;
}

.field {
  display: flex;
  margin-top: 12px;
  flex-wrap: wrap;
  max-width: 720px;
}

.field-content {
  font-size: 14px;
  color: #50607F;
  //margin-right: 10px;
}

.industryCount-content {
  font-size: 14px;
  color: #c3a062;
  font-weight: bold;
}

.load-button {
  background: #3860F4;
  border: none;
  width: 90px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #FFFFFF;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  flex-shrink: 0;
  user-select: none;
  &:not(:last-child) {
    margin-bottom: 15px;
  }
}

.alert-button {
  font-size: 16px;
  min-width: 124px;
  background: #3860F4;
  display: flex;
  justify-content: center;
  border: 1px solid #3860F4;
  border-radius: 8px;
  padding: 10px 17px;
  margin-left: 12px;
  color: white;
  height: fit-content;
  cursor: pointer;
}
.alert-button-black {
  background: #c8c9cc;
  border: 1px solid #c8c9cc;
  color: white;
  cursor: unset;
}

.latest-achievement {
  padding: 20px;
  background-color: #f9fafb;
  width: 340px;
  min-width: 340px;

  p {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 20px;

    span {
      max-width: 300px;
      font-size: 14px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: default;
    }

    img {
      margin-right: 10px;
    }
  }
}
.contact-way-layout {
  span:nth-child(1) {
    color: #828a9c;
    margin-bottom: 10px;
  }
  span:nth-child(2) {
    color: #3860F4;
  }
}

/deep/ .el-dialog {
  .el-button--primary {
    background-color: #0c78c1;
    border-color: #0c78c1;
  }

  .el-dialog__title {
    color: #101828;
  }
  .el-dialog__headerbtn .el-dialog__close {
    &:hover {
      color: #3860F4;
    }
  }
}
.last-achiv-layout {
  padding: 10px 25px;
  background: #fafafa;
  border: 1px solid #EEEEEE;
  border-top: none;
  border-radius: 0 0 12px 12px;
  .last-achiv-line {
    height: 1px;
    background-color: #eeeeee;
    width: 100%;
    margin-bottom: 10px;
  }
  .last-achiv-item {
  }
  .last-achiv-item:nth-child(1) {
    margin-right: 20px;
  }
  .last-achiv-item:nth-child(2) {
    margin-right: 20px;
  }

  .circle-icon {
    margin-right: 5px;
    height: 5px;
    min-width: 5px;
    background-color: #0c78c1;
    border-radius: 50%;
  }
  .last-achiv-title {
    span:nth-child(1) {
      font-size: 14px;
      color: #ffffff;
      display: inline-block;
      padding: 4px 6px;
    }
    span:nth-child(2) {
      margin-left: 7px;
      color: #334054;
      font-size: 16px;
    }
  }
  .last-achiv-title-paper {
    background: url('../../../assets/images/talent/search-paper-bg.png');
    background-size: 100% 100%;
  }
  .last-achiv-title-patent {
    background: url('../../../assets/images/talent/search-patent-bg.png');
    background-size: 100% 100%;
  }
  .last-achiv-title-project {
    background: url('../../../assets/images/talent/search-project-bg.png');
    background-size: 100% 100%;
  }
}

.infoLine {
  span {
    font-size: 14px;
    color: #8191B2  ;
  }
}

.infor-item {
  display: flex;
  margin-top: 12px;
  flex-wrap: wrap;
  width: 430px;
  color: #50607F;
}

.name-title-box {
  background: #fbe3cc;
  border-radius: 10px;
  color: #f45e1d;
  padding: 0 8px;
  font-size: 13px;
  height: 20px;
  line-height: 20px;
  &:not(:last-child) {
    margin-right: 10px;
  }
}
</style>

<style lang="less">
.test-tooltip {
  border: 1px solid #c0c1c3 !important;
  font-size: 14px;
  .popper__arrow {
    border-style: inset !important;
  }
}
</style>
